import { MenuItemStyled } from '@molecules/Filters/styles';
import { StyledSelect } from '../styles';
import { TCompanyAsset } from '../types';
import { Avatar, SelectChangeEvent, SelectProps, Stack } from '@mui/material';
import React from 'react';
import { StyledAssetSelectorWrapper } from './LinkManagementAssetSelect.styles';
interface ILinkManagementAssetSelect extends SelectProps {
  listAsset: TCompanyAsset[] | undefined;
  handleOnChange: (event: SelectChangeEvent<string>) => void;
}

const LinkManagementAssetSelect = ({
  listAsset,
  placeholder = 'Select option',
  handleOnChange,
  ...props
}: ILinkManagementAssetSelect) => {
  return (
    <StyledAssetSelectorWrapper>
      <StyledSelect
        id="AssetSelector"
        placeholder={placeholder}
        {...props}
        className="asset-selector"
        onChange={handleOnChange}
        sx={{ height: '50px' }}
      >
        {listAsset &&
          listAsset.map((item) => (
            <MenuItemStyled key={`${item?.id}-${item?.title}`} value={item?.id}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Avatar
                  src={item?.photoUrl}
                  sx={{
                    background: 'transparent',
                  }}
                  variant="square"
                />
                <span
                  title={item?.title}
                  className="asset-title font-semibold font-inter text-base leading-1-5"
                >
                  {item?.title}
                </span>
              </Stack>
            </MenuItemStyled>
          ))}
      </StyledSelect>
    </StyledAssetSelectorWrapper>
  );
};

export default React.memo(LinkManagementAssetSelect);
